import { render, staticRenderFns } from "./ExaminationExplain.vue?vue&type=template&id=2ae245d2&scoped=true"
import script from "./ExaminationExplain.vue?vue&type=script&lang=js"
export * from "./ExaminationExplain.vue?vue&type=script&lang=js"
import style0 from "./ExaminationExplain.vue?vue&type=style&index=0&id=2ae245d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae245d2",
  null
  
)

export default component.exports